import { Container } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';

const PaymentsLayout = () => {
	return (
		<Container maxWidth='lg' sx={{ mt: 4, mb: 4, height: '100%' }}>
			<Outlet />
		</Container>
	);
};

export default PaymentsLayout;
